import axios from 'axios';
import dayjs from 'dayjs';
import jwt_decode from 'jwt-decode';

import React, { useState, useEffect } from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import MonthRangePicker from '../common/MonthRangePicker.js'
import { grey } from '@mui/material/colors';

import BoxAroundTextField from '../common/BoxAroundTextField.js'
import HeadLine2 from '../common/HeadLine2.js'
import PicSelect2 from '../common/PicSelect2.js'
import StandardButton from '../common/StandardButton.js'
import copyTableToClipboard from '../utility/copyTableToClipboard.js'

export default function DailySales(props) {
  // const { token, salesMonth } = props;
  const { token } = props;

  const dateInMonth = [];

  for(let i = 1; i <= 31; i ++) {
    dateInMonth[i] = i
  }

  // getLastDayOfMonth(new Date())

  // const salesMonth = dayjs(new Date('2024/10/01'))

  // console.log(props.salesMonth)
  // console.log(token)

  const [dailyAmount1, setDailyAmount1] = useState([]);
  const [dailyAmount2, setDailyAmount2] = useState([]);
  const [dailyAmount3, setDailyAmount3] = useState([]);
  const [salesMonth, setSalesMonth] = React.useState(props.salesMonth);
  // const [endDate, setEndDate] = React.useState(dayjs(getLastDayOfMonth(new Date(props.salesMonth))));
  const [startEnabledMonth, setStartEnabledMonth] = React.useState(new Date());
  const [endEnabledMonth, setEndEnabledMonth] = React.useState(new Date());

  // console.log(startMonth);

  const [alertStatus, setAlertStatus] = useState({
    open: false,
    type: "success",
    message: ""
  });
  // const [employeeCode, setEmployeeCode] = React.useState(jwt_decode(token).employee_code);
  // const [employeeCode, setEmployeeCode] = React.useState("s0009");
  const [employeeCode, setEmployeeCode] = React.useState("");


  useEffect(() => {

  if (jwt_decode(token).role === '一般ユーザー' && jwt_decode(token).employee_code !== null) {
    setEmployeeCode(jwt_decode(token).employee_code);
  }

    const apiURL = process.env.REACT_APP_BASEURL;
    const periodGetURL = `${apiURL}/data_send/agency_sales_period`;

    axios({
      method: "GET",
      url:periodGetURL,
      headers: {
        Authorization: 'Bearer ' + token
      }
    })
    // axios.get(periodGetURL)
      .then(
        response => {

          // console.log(response);

          const tmpStartMonth = new Date(response.data.min_date)
          const tmpEndMonth = new Date(response.data.max_date)

          // console.log(tmpStartMonth);

          setStartEnabledMonth(tmpStartMonth)
          setEndEnabledMonth(tmpEndMonth)

          setStartEnabledMonth(tmpStartMonth)
          setEndEnabledMonth(tmpEndMonth)
        }
      );

  }, [])


  // const getData = () => {
    useEffect(() => {
    setAlertStatus({
      open: false,
      type: "close",
      message: ""
    });

    const apiURL = process.env.REACT_APP_BASEURL;
    const getURL = `${apiURL}/data_send/agency_sales_month?sales_month=${salesMonth.format('YYYYMM')}&employee_code=${employeeCode}`;


    axios({
      method: "GET",
      url: getURL,
      headers: {
        Authorization: 'Bearer ' + token
      }
    })
      .then(
        response => {

          // setBackdropOpen(false)

          // console.log(response);
          console.log(response.data.rows);
          // console.log(response.data.rows['ｶﾞﾗﾌｫﾙﾄﾞ ｶﾌﾟｾﾙ123mg']);

          if ('ｶﾞﾗﾌｫﾙﾄﾞ ｶﾌﾟｾﾙ123mg' in response.data.rows) {
            setDailyAmount1(response.data.rows['ｶﾞﾗﾌｫﾙﾄﾞ ｶﾌﾟｾﾙ123mg']);
            console.log(dailyAmount1)
          } else {
            setDailyAmount1([]);
          }

          if ('ﾎﾟﾑﾋﾞﾘﾃｨ点滴静注用105MG' in response.data.rows) {
            setDailyAmount2(response.data.rows['ﾎﾟﾑﾋﾞﾘﾃｨ点滴静注用105MG']);
            console.log(dailyAmount2)
          } else {
            setDailyAmount2([]);
          }

          if ('ｵﾌﾟﾌｫﾙﾀﾞｶﾌﾟｾﾙ65mg' in response.data.rows) {
            setDailyAmount3(response.data.rows['ｵﾌﾟﾌｫﾙﾀﾞｶﾌﾟｾﾙ65mg']);
            console.log(dailyAmount3)
          } else {
            setDailyAmount3([]);
          }

        }).catch((error) => {
          // setBackdropOpen(false)
          console.log('axios error');
          console.log(error);

          if (error.response) {
            setAlertStatus({
              open: true,
              type: "error",
              message: `接続エラー(${error.response.status})`
            });
          } else {
            setAlertStatus({
              open: true,
              type: "error",
              message: `エラー(${error})`
            });
          }
        }
        );




    // setBackdropOpen(true);
  // }
  }, [employeeCode, salesMonth])

  const handleEmployeeCode = (event) => {
    const {
      target: { value },
    } = event;

    console.log(value);
    setEmployeeCode(value);
  };

  return(
    <Box sx={{ p: 4 }}>
      <HeadLine2>
        ■ 日次データ
      </HeadLine2>

      <BoxAroundTextField>
        <MonthRangePicker
          value={salesMonth}
        minDate={startEnabledMonth}
        maxDate={endEnabledMonth}
        onChange={(newValue) => {
          setSalesMonth(newValue);
          // setEndDate(getLastDayOfMonth(newValue));
        }}
        />

        <PicSelect2
          token={token}
          employeeCode={employeeCode}
          handleEmployeeCode={handleEmployeeCode}
        />

        {/* <StandardButton onClick={getData}>検索</StandardButton> */}

      </BoxAroundTextField>

      <StandardButton variant="contained" color="primary" onClick={() => copyTableToClipboard('daily-table')}>
        クリップボードにコピー
      </StandardButton>

      <TableContainer component={Paper} sx={{ mt: 2 }}>
        <Table id="daily-table" sx={{ tableLayout: 'auto', width: '100%' }}>
          <TableHead>
            <TableRow>
              <TableCell
                align="left"
                // width={200}
                sx={{
                  // backgroundColor: grey[400],
                  // fontWeight: 'bold',
                  minWidth: 130
                }}
              >
                薬名
              </TableCell>
              {dateInMonth.map((row, index) => (
                <TableCell
                  align="right"
                  sx={{
                    backgroundColor: index % 2 === 1 ? 'backgroud.paper' : grey[200],
                    fontWeight: 'bold',
                    // width: 'auto'
                  }}
                >
                  {row}日
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            <TableRow>
              <TableCell
                align="left"
                sx={{
                  // backgroundColor: grey[400],
                  // fontWeight: 'bold',
                  // width: 'auto'
                }}
              >
                ガラフォルド
              </TableCell>
              {dailyAmount1.map((row, index) => (
                <TableCell
                  align="right"
                  sx={{
                    backgroundColor: index % 2 === 0 ? 'backgroud.paper' : grey[200],
                    fontWeight: 'bold',
                    // width: 'auto'
                  }}
                >
                  {row.amount}
                </TableCell>
              ))}
            </TableRow>
            <TableRow>
              <TableCell
                align="left"
                sx={{
                  // backgroundColor: grey[400],
                  // fontWeight: 'bold',
                  // width: 'auto'
                }}
              >
                ポムビリティ
              </TableCell>
              {dailyAmount2.map((row, index) => (
                <TableCell
                  align="right"
                  sx={{
                    backgroundColor: index % 2 === 0 ? 'backgroud.paper' : grey[200],
                    fontWeight: 'bold',
                    // width: 'auto'
                  }}
                >
                  {row.amount}
                </TableCell>
              ))}
            </TableRow>
            <TableRow>
              <TableCell
                align="left"
                sx={{
                  // backgroundColor: grey[400],
                  // fontWeight: 'bold',
                  // width: 'auto'
                }}
              >
                オプフォルダ
              </TableCell>
              {dailyAmount3.map((row, index) => (
                <TableCell
                  align="right"
                  sx={{
                    backgroundColor: index % 2 === 0 ? 'backgroud.paper' : grey[200],
                    fontWeight: 'bold',
                    // width: 'auto'
                  }}
                >
                  {row.amount}
                </TableCell>
              ))}
            </TableRow>
          </TableBody>

        </Table>
      </TableContainer>
    </Box>
  )
}